import type { Variables } from "../graphql";
import type { GqlObj } from "../graphql/types";
import { isGqlObject } from "../graphql/types";
import type { BaseQueryKey } from "../query/types";
import { hasOwnProperty } from "../utils";

export type QueryKey<TVars extends Variables | undefined = undefined> = [
  string,
  {
    query: GqlObj;
    graphQLEndpoint: string;
    variables: TVars | undefined;
    namespace?: string;
  },
];

export const isQueryKey = (queryKey: BaseQueryKey): queryKey is QueryKey => {
  return (
    Array.isArray(queryKey) &&
    typeof queryKey[0] === "string" &&
    hasOwnProperty(queryKey[1], "query") &&
    isGqlObject(queryKey[1].query)
  );
};
